var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.642 26C7.83 26 5.207 25.182 3 23.77c1.874.121 5.18-.169 7.238-2.131-3.094-.142-4.49-2.515-4.672-3.53.263.102 1.517.224 2.225-.06-3.56-.893-4.106-4.016-3.985-4.97.668.467 1.8.629 2.245.588-3.316-2.373-2.123-5.943-1.537-6.714 2.38 3.298 5.948 5.15 10.361 5.253a5.102 5.102 0 0 1-.127-1.135c0-2.8 2.264-5.071 5.056-5.071 1.46 0 2.774.62 3.697 1.611.975-.228 2.442-.763 3.16-1.226-.362 1.299-1.488 2.382-2.169 2.783.006.014-.006-.014 0 0 .598-.09 2.216-.402 2.856-.835-.316.729-1.51 1.941-2.49 2.62C25.042 18.99 18.894 26 10.643 26z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.412fa31841b8fbfedec1b5f148cc59d9.svg";
export { ForwardRef as ReactComponent };